<template>
	<div class="layer-project" data-project-name="lotte-tms">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<!-- Page Contents -->
			<section class="project-visual">
				<div>
					<h1 class="project-tit">LOTTE HOTEL <br />Table Management System</h1>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						롯데호텔 식음업장의 간편한 예약서비스 제공 및 효율적인 업장관리를
						위한 TMS (Table management System)을 구축하였습니다. <br />4개언어
						및 웹, 모바일 지원을 통해 고객 예약편의성을 확보하였으며, 일단위로
						가격정책, 매장 레이아웃 구성을 설정할 수 있도록 하여
						<span class="ib">효율적인 Revenue Management 및</span>
						<span class="ib">Inventory 관리를</span> 할 수 있도록
						제작하였습니다.
					</p>
					<div class="project-overview-diagram clfix">
						<ul class="diagram01">
							<li class="item01">Brand <br />Identity</li>
							<li class="item02">UI/UX Design</li>
							<li class="item03">Reservation <br />System</li>
						</ul>
						<ul class="diagram02">
							<li class="item04">Lotte <br />Hotel TMS</li>
						</ul>
					</div>
				</div>
			</section>
			<!-- Details [e] -->

			<section class="section section01">
				<div class="inner-section">
					<strong class="project-subtit">PC Web</strong>
					<p class="sub-text">
						메인에 예약시스템이 강조되어있어 사용자의 예약시스템에 대한 동선을
						짧고 편리하게 하였습니다. <br />각각의 페이지에 많은 내용 보다는
						짧고 간결한 내용으로 구성함으로써 불필요한 정보는 최소화하고 핵심
						기능과 중요컨텐츠를 직관적으로 표현하였습니다. <br />핵심 정보
						중심의 직관적인 표현으로 사용자의 다음 프로세스에 대한 과정을 쉽고
						빠르게 이어질 수 있도록 유도하였습니다.
					</p>
					<div class="pc-web-top-img">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lotte-tms/pc-web-img01@m.png"
							/>
						</div>
					</div>
					<div class="pc-web-sub-img clfix">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lotte-tms/pc-web-img02@m.png"
							/>
						</div>
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lotte-tms/pc-web-img03@m.png"
							/>
						</div>
					</div>
				</div>
			</section>

			<section class="section section02 full">
				<div class="inner-section">
					<div class="mobile-web-top clfix">
						<div class="mobile-web-info">
							<strong class="project-subtit">Mobile Web</strong>
							<p class="sub-text">
								웹 사이트와 동일하게 롯데호텔 식음예약시스템의 서비스를
								<span class="ib">모바일 환경에 최적화된</span>
								<span class="ib">UI/UX를 제공하여</span> 사용자의 동선을 최소화
								하도록 구성하였습니다.
							</p>
						</div>
						<div class="mobile-web-top-img clfix">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-tms/mobile-web-img01@m.png"
								/>
							</div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-tms/mobile-web-img02@m.png"
								/>
							</div>
						</div>
					</div>
					<div class="mobile-web-sub-img clfix">
						<div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-tms/mobile-web-img03@m.png"
								/>
							</div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-tms/mobile-web-img05@m.png"
								/>
							</div>
						</div>
						<div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-tms/mobile-web-img04@m.png"
								/>
							</div>
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-tms/mobile-web-img06@m.png"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section class="section section03">
				<div class="inner-section">
					<div class="point-top-area clfix">
						<div class="point-font-area">
							<div class="img">
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/lotte-tms/point-font-img@mt.png"
									data-break="mt-w"
								/>
							</div>
						</div>
						<div class="point-color-area clfix">
							<ul class="clfix">
								<li class="item01"><span>#9e8361</span></li>
								<li class="item02"><span>#9c9c9c</span></li>
								<li class="item03"><span>#756752</span></li>
							</ul>
						</div>
					</div>
					<div class="point-icon-area">
						<div class="img">
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/lotte-tms/point-icon-img@m.png"
							/>
						</div>
					</div>
				</div>
			</section>

			<section class="project-client">
				<strong class="a11y-hidden">D.Steady Mall</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();
	},
	methods: {},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* Common */
@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
}
@media screen and (min-width: 1280px) {
}

/* Project Visual, Project CI */
.project-client {
	background: url(/static/img/project-detail/lotte-tms/ci.png) 50% / auto 137px
		no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-tms/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-tms/bg-overview@t.jpg);
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/lotte-tms/bg-overview@w.jpg);
	}
	.project-client {
		background-size: auto 356px;
	}
}

/* Overview */
.project-overview {
	background-color: #78664e;
	color: #fff;
}

.project-overview-diagram {
	margin-top: 25px;
}
.project-overview-diagram .diagram01:after {
	content: "";
	display: block;
	clear: both;
}
.project-overview-diagram li {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	width: 138px;
	height: 138px;
	font-weight: 500;
	border: 1px solid #fff;
	border-radius: 50%;
	text-align: center;
}
.diagram01 {
	position: relative;
	display: flex;
	align-items: center;
	flex-flow: wrap row;
}
.diagram01:after {
	content: "";
	position: absolute;
	bottom: 0;
	left: 50%;
	width: 1px;
	height: 42px;
	background-color: #fff;
}
.diagram02 li {
	margin: 0 auto;
	font-size: 16px;
	line-height: 19px;
	background-color: #fff;
	color: #78664e;
	text-transform: uppercase;
}
@media screen and (max-width: 711px) {
	.project-overview-diagram {
		padding-top: 13px;
	}
	.diagram01 {
		justify-content: center;
		margin-bottom: 10px;
		padding-bottom: 33px;
	}
	.diagram01 li {
		margin: -13px -4px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		width: 632px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.project-overview-diagram li {
		width: 132px;
		height: 132px;
	}
	.diagram01 {
		float: left;
		padding-left: 4px;
		padding-right: 107px;
	}
	.diagram01:after {
		bottom: 50%;
		left: auto;
		right: 0;
		width: 87px;
		height: 1px;
	}
	.diagram01 li {
		margin: 0 -4px;
	}
	.diagram02 {
		float: right;
	}
	.diagram02 li {
		margin: auto;
		font-size: 15px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview .inner-section {
		padding-bottom: 54px;
	}
	.project-overview-txt {
		width: 855px;
	}
	.project-overview-diagram {
		width: 1130px;
		margin: 0 auto;
		margin-top: 80px;
	}
	.project-overview-diagram li {
		width: 230px;
		height: 230px;
		font-size: 20px;
		border-width: 2px;
	}
	.diagram01 {
		padding-left: 7px;
		padding-right: 217px;
	}
	.diagram01:after {
		bottom: calc(50% - 1px);
		width: 178px;
		height: 2px;
	}
	.diagram01 li {
		margin: 0 -7px;
	}
	.diagram02 li {
		margin: auto;
		font-size: 28px;
		line-height: 30px;
	}
}

.section01 {
	position: relative;
	padding-bottom: 20px;
	background-color: #f4f4f4;
}
.section01:after {
	content: "";
	position: absolute;
	left: 0;
	bottom: 69px;
	width: 100%;
	height: calc(100vw * (176.5 / 320));
	background-color: #ac8754;
}
.section01 div {
	position: relative;
	z-index: 1;
}
.section01 .sub-text {
	margin-bottom: 30px;
	word-break: keep-all;
}
.section01 .pc-web-top-img {
	margin-bottom: 20px;
}
.section01 .pc-web-top-img .img {
	text-align: center;
}
.section01 img {
	border-radius: 5px;
	box-shadow: 0 21px 34px rgba(0, 0, 0, 0.17);
}
.section01 .pc-web-sub-img {
	position: relative;
	left: 14.0625vw;
	width: 125vw;
}
.section01 .pc-web-sub-img > div {
	float: left;
	width: 60.9375vw;
}
.section01 .pc-web-sub-img > div + div {
	margin-left: 10px;
}

@media screen and (max-width: 711px) {
}
@media screen and (min-width: 712px) {
	.section01 {
		padding-bottom: 40px;
	}
	.section01:after {
		bottom: 140px;
		height: calc(100vw * (415 / 712));
	}
	.section01 .inner-section {
		padding-bottom: 23px;
	}
	.section01 .pc-web-top-img {
		margin-bottom: 56px;
	}
	.section01 .pc-web-sub-img {
		left: 137.5px;
		width: 101.4044vw;
	}
	.section01 .pc-web-sub-img > div {
		width: 49.4382vw;
	}
	.section01 .pc-web-sub-img > div + div {
		margin-left: 18px;
	}
}
@media screen and (min-width: 1280px) {
	.section01:after {
		bottom: 326px;
		height: 845px;
	}
	.section01 .inner-section {
		padding-top: 100px;
		padding-bottom: 125px;
	}
	.section01 img {
		border-radius: 20px;
		box-shadow: 0 42px 73px rgba(0, 0, 0, 0.17);
	}
	.section01 .pc-web-sub-img {
		left: 383px;
		width: 1604px;
	}
	.section01 .pc-web-sub-img > div {
		width: 782px;
	}
	.section01 .pc-web-sub-img > div + div {
		margin-left: 40px;
	}
}

.section02 .sub-text {
	word-break: keep-all;
}
.section02 .inner-section {
	padding-bottom: 20px;
}
.section02 .mobile-web-top {
	margin-bottom: 40px;
	padding: 0 15px;
}
.section02 .mobile-web-top-img > div {
	float: left;
	width: calc(50% - 11px);
}
.section02 .mobile-web-top-img > div + div {
	margin-top: 55px;
	margin-left: 22px;
}
.section02 .mobile-web-top-img img {
	border-radius: 15px;
	box-shadow: 16px 16px 20px rgba(0, 0, 0, 0.22);
}
.section02 .mobile-web-sub-img {
	padding: 0 15px;
}
.section02 .mobile-web-sub-img > div {
	float: left;
}

@media screen and (max-width: 711px) {
	.section02 .mobile-web-info {
		margin-bottom: 30px;
	}
	.section02 .mobile-web-top-img {
		max-width: 556px;
		margin: 0 auto;
	}
	.section02 .mobile-web-top-img > div {
		max-width: 267px;
	}
	.section02 .mobile-web-sub-img {
		position: relative;
		max-width: 585px;
		margin: 0 auto;
	}
	.section02 .mobile-web-sub-img > div {
		width: calc(50% - 13px);
		max-width: 265px;
	}
	.section02 .mobile-web-sub-img > div .img + .img {
		margin-top: 50px;
	}
	.section02 .mobile-web-sub-img > div:nth-child(2) {
		margin-left: 25px;
	}
}
@media screen and (min-width: 712px) {
	.section02 .mobile-web-info {
		float: left;
		width: 250px;
	}
	.section02 .mobile-web-top {
		margin-bottom: 60px;
		padding: 0 40px;
	}
	.section02 .mobile-web-top-img {
		float: right;
		width: 47.3314vw;
	}
	.section02 .mobile-web-top-img > div {
		float: left;
		width: 22.191vw;
	}
	.section02 .mobile-web-top-img > div + div {
		margin-top: 64px;
		margin-left: 21px;
	}

	.section02 .mobile-web-sub-img {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: space-between;
		padding: 0 40px;
	}
	.section02 .mobile-web-sub-img:after {
		content: none;
	}
	.section02 .mobile-web-sub-img > div {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: space-between;
		width: 47%;
	}
	.section02 .mobile-web-sub-img > div .img {
		width: 18.9606vw;
	}
	.section02 .mobile-web-sub-img > div .img + .img {
		margin-left: 0;
	}
}
@media screen and (min-width: 1280px) {
	.section02 .inner-section {
		position: relative;
		padding-bottom: 1737px;
	}
	.section02 .mobile-web-info {
		width: 315px;
		padding-top: 50px;
	}
	.section02 .mobile-web-top {
		width: 1280px;
		margin: 0 auto 124px;
	}
	.section02 .mobile-web-top-img img {
		border-radius: 30px;
		box-shadow: 33px 33px 40px rgba(0, 0, 0, 0.22);
	}
	.section02 .mobile-web-top-img {
		width: 748px;
	}
	.section02 .mobile-web-top-img > div {
		width: 351px;
	}
	.section02 .mobile-web-top-img > div + div {
		margin-top: 143px;
		margin-left: 46px;
	}
	.section02 .mobile-web-sub-img {
		position: absolute;
		left: 50%;
		width: 1440px;
		margin-left: -720px;
		padding: 0;
	}
	.section02 .mobile-web-sub-img > div {
		width: calc(50% - 30px);
	}
	.section02 .mobile-web-sub-img > div .img {
		width: 311px;
	}
}

.section03 {
	background-color: #e9e9e9;
}
.section03 .point-font-area .img {
	width: 256px;
}
.section03 .point-top-area {
	margin-bottom: 35px;
}
.section03 .point-color-area ul {
	width: 255px;
	margin: 0 auto;
}
.section03 .point-color-area li {
	position: relative;
	float: left;
	width: 85px;
	height: 85px;
	color: #fff;
	box-shadow: 16px 16px 20px rgba(0, 0, 0, 0.2);
}
.section03 .point-color-area li.item01 {
	background-color: #9e8361;
}
.section03 .point-color-area li.item02 {
	background-color: #9c9c9c;
}
.section03 .point-color-area li.item03 {
	background-color: #756752;
}
.section03 .point-color-area li span {
	position: absolute;
	bottom: 13px;
	left: 0;
	width: 100%;
	font-size: 13px;
	text-align: center;
}
.section03 .point-icon-area .img {
	width: 255px;
	margin: 0 auto;
}

@media screen and (max-width: 711px) {
	.section03 .point-font-area {
		margin-bottom: 30px;
		padding-bottom: 30px;
		border-bottom: 1px solid #ccc;
	}
}
@media screen and (min-width: 712px) {
	.section03 .inner-section {
		padding: 20px 0;
	}
	.section03 .point-top-area {
		width: 632px;
		margin: 0 auto;
		margin-bottom: 45px;
	}
	.section03 .point-top-area > div {
		float: left;
		width: 50%;
	}
	.section03 .point-color-area ul {
		float: right;
		margin: auto;
	}
	.section03 .point-icon-area .img {
		width: 632px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 .inner-section {
		padding-top: 160px;
		padding-bottom: 80px;
	}
	.section03 .point-top-area {
		width: auto;
		margin-bottom: 130px;
	}
	.section03 .point-font-area .img {
		width: 642px;
	}
	.section03 .point-color-area ul {
		width: 468px;
	}
	.section03 .point-color-area li {
		width: 156px;
		height: 156px;
		box-shadow: 33px 33px 40px rgba(0, 0, 0, 0.2);
	}
	.section03 .point-color-area li span {
		bottom: 18px;
		padding-right: 22px;
		font-size: 16px;
		text-align: right;
	}
	.section03 .point-icon-area .img {
		width: auto;
	}
}
</style>



// WEBPACK FOOTER //
// src/projects/lotte-tms.vue